import React from "react";
import Webcam from "react-webcam";
import RoundButton from "../../../Common/RoundButton";
import {FlipCameraIos} from '@mui/icons-material';
const WebCam = ({
    capture,
    webcamRef,
    handleCameraFlip,
    facingModeCamera
}: any) => {
    const videoConstraints = {
        // width: 1280,
        // height: 720,
        facingMode: facingModeCamera ? { exact: "environment" } : "user"
        //  facingMode: { exact: "environment" }
      };
    return (
        <>
            <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                
                    <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={320}
                        videoConstraints={videoConstraints}
                    />
                   
            </div>
             <div onClick={handleCameraFlip}>
                        <FlipCameraIos
                            name ="camera-flip-outline"/>
                            </div>
            <div style={{ marginTop: '20px' }}>
                        <RoundButton onClick={capture} title={"Take Picture"} />
                       
                    </div>

        </>

    );
};

export default WebCam;

